import { FieldDataInterface } from "./settings-custom-form-field-data.model";
import { v4 as uuidv4 } from 'uuid';

export abstract class SettingsCustomFormFieldData {
    id: string;
    type: string;
    label: string;
    position: number;
    active: boolean;
    mandatory: boolean;
    changed: boolean;
    constructor(type: string, position: number, id?: string, label?: string, mandatory?: boolean, active?: boolean) {
        this.type = type;
        this.position = position;
        // default or recovered values using nullish coalescing '??' for set values or default when null.
        this.id = id ?? SettingsCustomFormFieldData.newUuid();
        this.label = label ?? '';
        this.mandatory = mandatory ?? false; 
        this.active = active ?? true;
        // Set changed to true if when not any optional parameter was explicitly provided
        this.changed = !(id || label || mandatory !== undefined || active !== undefined);
    }

    static newUuid(): string {
        return uuidv4();
    }


    // method to get data to send to backedn for each field.
    protected _serialize(options: any): FieldDataInterface {
        return {
            "id": this.id,
            "type": this.type,
            "label": this.label,
            "mandatory": this.mandatory,
            "position": this.position,
            "active": this.active,
            "options": options
        };
    }

    public abstract serialize() : FieldDataInterface;
    public abstract deserialize(field: FieldDataInterface) : SettingsCustomFormFieldData;

    public abstract update(data: Partial<SettingsCustomFormFieldData>) : SettingsCustomFormFieldData;

}

